import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/workspace/src/components/mdx/MdxLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeHike = makeShortcode("CodeHike");
const StepHead = makeShortcode("StepHead");
const Focus = makeShortcode("Focus");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`date: 2021-07-09
author: Johannes Klauss
title: A gentle introduction to Recoil.js
subtitle: Recoil JS
tags: State, Concepts
intro: Managing complex state is React is hard. Recoil simplifies it.`}</p>


    <CodeHike mdxType="CodeHike">
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js",
            "App.js": true
          }}>{`import React, {useState} from "react"

export default function App() {
  const [count, setCount] = useState(0);

  return (
    <>
      <h1>
        The count is: {count}
      </h1>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`This is some introductory text, explaining what you want to do with some starting code example.`}</p>
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js focus=3[16:29]",
            "App.js": true,
            "focus": "3[16:29]"
          }}>{`import React, {useState} from "react"

export default function App() {
  const [count, setCount] = useState(0);

  return (
    <>
      <h1>
        The count is: {count}
      </h1>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`Then you might add some focus on the code, to explain specific things about it.`}</p>
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js focus=4:7",
            "App.js": true,
            "focus": "4:7"
          }}>{`import React, {useState} from "react"

export default function App() {
  const [count, setCount] = useState(0);

  return (
    <>
      <h1>
        The count is: {count}
      </h1>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`While we can focus while scrolling, we can also `}<Focus on="9[23:29]" mdxType="Focus">{`focus on code with a link`}</Focus>{`.`}</p>
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js focus=11:12",
            "App.js": true,
            "focus": "11:12"
          }}>{`import React, {useState} from "react"

export default function App() {
  const [count, setCount] = useState(0);

  return (
    <>
      <h1>
        The count is: {count}
      </h1>
      <button>Increase Count</button>
      <button>Decrease Count</button>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`We can add stuff to the code and it will get reflected in the output.`}</p>
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js focus=5:7,14[15:32],15[15:32]",
            "App.js": true,
            "focus": "5:7,14[15:32],15[15:32]"
          }}>{`import React, {useState} from "react"

export default function App() {
  const [count, setCount] = useState(0);

  const increase = () => setCount(count + 1);
  const decrease = () => setCount(count - 1);

  return (
    <>
      <h1>
        The count is: {count}
      </h1>
      <button onClick={increase}>Increase Count</button>
      <button onClick={decrease}>Decrease Count</button>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`Our output is actually interactive and renders the exact component we display.`}</p>
      <StepHead mdxType="StepHead">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "Headline.js",
            "Headline.js": true
          }}>{`import React, {useState} from "react"

export default function Headline(props) {

  return (
    <>
      <h1>The count is: {props.count}</h1>
    </>
  )
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "App.js",
            "App.js": true
          }}>{`import React, {useState} from "react"
import Headline from "./Headline"

export default function App() {
  const [count, setCount] = useState(0);

  const increase = () => setCount(count + 1);
  const decrease = () => setCount(count - 1);

  return (
    <>
      <Headline count={count}/>
      <button onClick={increase}>Increase Count</button>
      <button onClick={decrease}>Decrease Count</button>
    </>
  )
}
`}</code></pre>
      </StepHead>
      <p>{`We can also display and connect multiple files. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.`}</p>
      <pre><code parentName="pre" {...{}}>{`                                            Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet,
`}</code></pre>
    </CodeHike>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      